import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AuthGuard } from './core/guards/auth.guard';
import { LayoutComponent } from './layouts/layout.component';
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';
import { accountGuard } from './core/guards/account.guard';
import { ManagedInstructionsGuard } from './core/guards/managed-instructions.guard';

const routes: Routes = [
  { path: 'account', loadChildren: () => import('./account/account.module').then(m => m.AccountModule), canActivate: [accountGuard] },
  { path: 'privacy', component: PrivacyPolicyComponent},
  { path: 'managed/instructions', loadChildren: ()=> import('./instructions/instructions.module').then(m=> m.InstructionsModule), canActivate: [ManagedInstructionsGuard]},
  { path: '404', loadComponent: () => import('./not-found/not-found.component').then(m => m.NotFoundComponent) },
  // tslint:disable-next-line: max-line-length
  { path: '', component: LayoutComponent, loadChildren: () => import('./pages/pages.module').then(m => m.PagesModule), canActivate: [AuthGuard] },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'top' , bindToComponentInputs: true })],
  exports: [RouterModule]
})

export class AppRoutingModule { }
// canActivate: [AuthGuard]
